var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconTakes = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.17084 4.97462L9.28978 4.4678L8.17084 3.96097L7.66223 2.84596L7.15362 3.96097L6.03469 4.4678L7.15362 4.97462L7.66223 6.08963L8.17084 4.97462ZM5.09377 6.7485L6.59416 6.08963L5.09377 5.40542L4.40715 3.91029L3.74596 5.40542L2.24557 6.08963L3.74596 6.7485L4.40715 8.24362L5.09377 6.7485ZM8.75574 0.666626H10.9173V8.24362C10.9173 8.53082 10.8071 8.78423 10.5867 9.00386C10.3833 9.22348 10.1375 9.33329 9.84924 9.33329H1.15206C0.863849 9.33329 0.609545 9.22348 0.389149 9.00386C0.185706 8.78423 0.0839844 8.53082 0.0839844 8.24362V1.75629C0.0839844 1.4691 0.185706 1.21568 0.389149 0.996061C0.609545 0.776438 0.863849 0.666626 1.15206 0.666626H1.71153L2.7796 2.28846H4.40715L3.33907 0.666626H4.40715L5.50065 2.28846H7.12819L6.03469 0.666626H7.12819L8.2217 2.28846H9.84924L8.75574 0.666626Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconTakes);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-takes.7ecbfb494552c8cd90f9165f480b9e11.svg";